import type { JSX } from 'react';
import type { HearingLossAssessmentDataV2 } from '@common/validation/customControls/hearingLoss/hearingLossAssessment/hearingLossAssessmentV2';
import type { InputComponentsMap } from '@frontend/formEngine/editForm/editForm.types';
import { getInputField } from '@common/formEngine/typedSections';
import { hearingLossAssessmentSectionsV2 } from '@common/validation/customControls/hearingLoss/hearingLossAssessment/hearingLossAssessmentV2';
import { redenReceptData } from '@common/validation/customControls/hearingLoss/utils';
import { EditForm } from '@frontend/formEngine/editForm/EditForm';
import { FormParagraphFormGroupPrefilled } from '../../hearingLossComponents/FormParagraphFormGroupPrefilled';

export function HearingLossAssessmentEditV2(): JSX.Element {
    return (
        <EditForm
            inputComponents={getInputComponents()}
            sections={hearingLossAssessmentSectionsV2}
        />
    );
}

function getInputComponents(): InputComponentsMap<keyof HearingLossAssessmentDataV2> {
    const map: InputComponentsMap<keyof HearingLossAssessmentDataV2> = new Map();

    for (const { key, value } of redenReceptData) {
        map.set(
            key,
            <FormParagraphFormGroupPrefilled
                fieldKey={key}
                label={getInputField(hearingLossAssessmentSectionsV2, key).label}
                value={value}
            />
        );
    }

    return map;
}
